import { render } from "./RoomFile.vue?vue&type=template&id=3f267245"
import script from "./RoomFile.vue?vue&type=script&lang=js"
export * from "./RoomFile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__